import { privacyPolicyDescriptionMock } from "../editable/privacy-policy/privacy-policy1/privacy-policy-mock";
import { ComponentsBaseProps } from "../types";
import {
  ComponentNames,
  ContactActionButtonType,
  ContactActionType,
  FieldParams,
  IComponentsMocks,
  TypeFieldParams,
} from "./props";
import { ActionType, FieldName } from "../editable/forms/props";

//@ts-ignore
export const componentsMocks: Map<
  ComponentNames,
  IComponentsMocks<ComponentsBaseProps, FieldParams>
> = new Map(
  Object.entries({
    About1: {
      id: "About1",
      componentName: "About1",
      position: 0,
      isSortable: true,
      isSmartComponent: false,
      isDeletable: true,
      isEditable: true,
      label: "Sobre nós",
      advancedConfig: false,
      styles: {
        classes: [
          ".container",
          ".wrapper",
          ".wrapper--invert",
          ".wrapper__invert",
          ".text-wrapper",
          ".image-container",
          ".container__image",
          ".container__content",
          ".content__wrapper",
          ".title",
          ".image",
        ],
        value: null,
        label: "CSS",
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
        ],
      },
      heading: {
        label: "Titulo",
        type: TypeFieldParams.Text,
        value: "Sobre Nós",
      },
      description: {
        label: "Descrição",
        type: TypeFieldParams.Textarea,
        value: `<p>Contrary to popular belief, Lorem Ipsum is not simply random text.
      It has roots in a piece of classical Latin literature from 45 BC,
      making it over 2000 years old. Richard McClintock, a Latin professor
      at Hampden-Sydney College in Virginia, looked up one of the more
      obscure Latin words, consectetur, from a Lorem Ipsum passage, and
      going through the cites of the word in classical literature,
      discovered the undoubtable source. Lorem Ipsum comes from sections
      1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes
      of Good and Evil) by Cicero, written in 45 BC. This book is a
      treatise on the theory of ethics, very popular during the
      Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit
      amet..", comes from a line in section 1.10.32.</p>
      <br />
      <p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced
      below for those interested. Sections 1.10.32 and 1.10.33 from "de
      Finibus Bonorum et Malorum" by Cicero are also reproduced in their
      exact original form, accompanied by English versions from the 1914
      translation by H. Rackham.</p>
      `,
      },
      inverter: {
        type: TypeFieldParams.Checkbox,
        label: "Inverter?",
        value: false,
      },
      image: {
        type: TypeFieldParams.Image,
        label: "Imagem",
        value: "https://via.placeholder.com/350x350.png",
      },
    },
    OpeningHours1: {
      id: "OpeningHours1",
      position: 0,
      componentName: "OpeningHours1",
      isSortable: true,
      isDeletable: true,
      isSmartComponent: false,
      isEditable: true,
      label: "Horário de Funcionamento",
      advancedConfig: false,
      styles: {
        classes: [
          ".container",
          ".section",
          ".wrapper-header",
          ".title",
          ".description",
          ".content-wapper",
          ".column",
          ".divider",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
        ],
      },
      sales_monday: {
        label: "Segunda-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      sales_tuesday: {
        label: "Terça-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      sales_wednesday: {
        label: "Quarta-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      sales_thursday: {
        label: "Quinta-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      sales_friday: {
        label: "Sexta-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      sales_saturday: {
        label: "Sábado",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      sales_sunday: {
        label: "Domingo",
        type: TypeFieldParams.Text,
        value: "Fechado",
      },
      finance_monday: {
        label: "Segunda-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      finance_tuesday: {
        label: "Terça-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      finance_wednesday: {
        label: "Quarta-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      finance_thursday: {
        label: "Quinta-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      finance_friday: {
        label: "Sexta-feira",
        type: TypeFieldParams.Text,
        value: "08:00 às 18:00",
      },
      finance_saturday: {
        label: "Sábado",
        type: TypeFieldParams.Text,
        value: "Fechado",
      },
      finance_sunday: {
        label: "Domingo",
        type: TypeFieldParams.Text,
        value: "Fechado",
      },
    },
    Navigation: {
      id: "Navigation",
      position: 0,
      componentName: "Navigation",
      isSortable: true,
      isDeletable: true,
      isSmartComponent: true,
      isEditable: true,
      label: "Componente de Navegação",
      advancedConfig: false,
      smartFeatureName: "inventory",
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
      styles: {
        classes: [".section", ".container", ".list__item"],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
        ],
      },
    },
    FAQ: {
      id: "FAQ",
      position: 0,
      componentName: "FAQ",
      isSortable: true,
      isDeletable: true,
      isSmartComponent: true,
      isEditable: true,
      label: "Componente FAQ",
      advancedConfig: false,
      smartFeatureName: "inventory",
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
      styles: {
        classes: [".section", ".container", ".list__item"],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
        ],
      },
    },
    CtaPremium1: {
      id: "CtaPremium1",
      position: 1,
      componentName: "CtaPremium1",
      isSortable: true,
      isDeletable: true,
      isSmartComponent: false,
      isEditable: true,
      label: "Call to Action Premium",
      advancedConfig: false,
      styles: {
        classes: [".container", ".wrapper"],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      image: {
        label: "Imagem",
        type: TypeFieldParams.Image,
        value: "https://via.placeholder.com/350x350.png",
      },
      heading: {
        label: "Titulo",
        type: TypeFieldParams.Text,
        value: "Módulo Premium",
      },
      description: {
        label: "Descrição",
        type: TypeFieldParams.Textarea,
        value:
          "Luxo e desempenho em harmonia: explore nossa linha premium de veículos, onde cada escolha é uma experiência única.",
      },
    },
    Cta1: {
      id: "Cta1",
      componentName: "Cta1",
      position: 0,
      isSortable: true,
      isSmartComponent: true,
      isDeletable: true,
      label: "Call to Action",
      isEditable: true,
      hasButton: true,
      advancedConfig: true,
      styles: {
        classes: [
          ".container",
          ".wrapper",
          ".text-wrapper",
          ".image-container",
          ".image-wrapper",
          ".image",
          ".quote",
          ".description",
          ".button-container",
          ".button",
          ".vendor-name-container",
          ".icon",
          ".overlay",
          ".container-actions",
          ".close-icon",
          ".short-description",
          ".header-vendor-name",
          ".header-content",
          ".menu-header",
          ".menu-container",
          ".menu-icon",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      heading: {
        label: "Titulo",
        type: TypeFieldParams.Text,
        value: "Qualidade e excelência",
      },
      instagramUrl: {
        label: "Link do Instagram",
        type: TypeFieldParams.Text,
        value: "https://www.instagram.com.br",
      },
      workflowId: {
        label: "N8N workflow GUID",
        type: TypeFieldParams.Text,
        value: "78daf378-240c-430d-80aa-67c2d0ebd6",
      },
      image: {
        label: "Imagem",
        type: TypeFieldParams.Image,
        value: "https://via.placeholder.com/350x350.png",
      },
      qrCodeImage: {
        label: "QR Code do vendedor",
        type: TypeFieldParams.Image,
        value: "https://via.placeholder.com/350x350.png",
      },
      emailToSendLead: {
        label: "Email que receberá leads",
        type: TypeFieldParams.Text,
        value: "example@email.com",
      },
      description: {
        label: "Descrição",
        type: TypeFieldParams.Textarea,
        value:
          "O melhor atendimento e os melhores veículos esperam por você. Agende uma visita e encontre o carro dos seus sonhos.",
      },
      shortDescription: {
        label: "Descrição curta (cargo e loja)",
        type: TypeFieldParams.Text,
        value: "Vendedor - Example Motors",
      },
      quote: {
        label: "Bordão",
        type: TypeFieldParams.Text,
        value: "Uma nova forma de pensar",
      },
      vendorName: {
        label: "Nome do vendedor",
        type: TypeFieldParams.Text,
        value: "Fulano da Silva",
      },
      vendorPhone: {
        label: "Telefone do vendedor",
        type: TypeFieldParams.Text,
        value: "(11) 9 9999 9999",
      },
      whatsappVendorPhone: {
        label: "Whatsapp do vendedor",
        type: TypeFieldParams.Text,
        value: "(11) 9 9999 9999",
      },
      highlight: {
        label: "Destaque",
        type: TypeFieldParams.Text,
        value: "Não perca!",
      },
      companyPosition: {
        label: "Cargo",
        type: TypeFieldParams.Text,
        value: "Vendedor",
      },
      company: {
        label: "Empresa",
        type: TypeFieldParams.Text,
        value: "Nome da empresa",
      },
      action: {
        id: "0",
        label: "Botão",
        type: TypeFieldParams.Action,
        value: "Botão",

        icon: true,
        link: "/estoque",
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
        ],
      },
      links: {
        label: "Links",
        type: TypeFieldParams.Collection,
        items: [
          {
            type: TypeFieldParams.Text,
            label: "Instagram",
            value: "https://instagram.com",
          },
          {
            type: TypeFieldParams.Text,
            label: "Facebook",
            link: "https://www.facebook.com",
            value: "https://www.facebook.com",
          },
          {
            type: TypeFieldParams.Text,
            label: "Site",
            value: "https://www.site.com",
          },
        ],
      },
      smartFeatureName: "inventory",
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
    },
    FloatingWhatsApp1: {
      id: "FloatingWhatsApp1",
      componentName: "FloatingWhatsApp1",
      position: 0,
      isDeletable: true,
      isEditable: true,
      isSortable: true,
      isSmartComponent: false,
      label: "WhatsApp Flutuante",
      advancedConfig: false,
      styles: {
        classes: [".icon"],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      vendorWhatsAppPhone1: {
        label: "WhatsApp da loja",
        type: TypeFieldParams.Text,
        value: "11999999999",
      },
    },
    Header: {
      id: "Header",
      componentName: "Header",
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      position: 1,
      isDeletable: true,
      isEditable: true,
      isSortable: true,
      isSmartComponent: false,
      label: "Cabeçalho",
      advancedConfig: false,
      styles: {
        classes: [
          ".container",
          ".wrapper",
          ".image-wrapper",
          ".image",
          ".menu-mobile",
          ".menu-container",
          ".menu-container--open",
          ".menu-item",
          ".wrapper--variant-1",
          ".wrapper--variant-2",
          ".wrapper--variant-3",
          ".wrapper--variant-4",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      logo: {
        label: "Logo para o tema claro",
        type: TypeFieldParams.Image,
        value:
          "https://sync-platforms.s3.sa-east-1.amazonaws.com/logo-default.svg",
      },
      logoDark: {
        label: "Logo para o tema escuro",
        type: TypeFieldParams.Image,
        value:
          "https://sync-platforms.s3.sa-east-1.amazonaws.com/logo-default.svg",
      },
      logoWidth: {
        label: "Largura do logo",
        type: TypeFieldParams.Number,
        value: 80,
      },
      logoHeight: {
        label: "Altura do logo",
        type: TypeFieldParams.Number,
        value: 80,
      },
      defaultTheme: {
        label: "Qual será o tema padrão do site?",
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "Claro", value: "light" },
          { label: "Escuro", value: "dark" },
        ],
        value: "light",
      },
      menus: {
        label: "Links",
        type: TypeFieldParams.Collection,

        items: [
          {
            type: TypeFieldParams.Text,
            label: "Home",
            link: "/",
            value: "/",
          },
          {
            type: TypeFieldParams.Text,
            label: "Estoque",
            link: "/estoque/todos",
            value: "/estoque/todos",
          },
          {
            type: TypeFieldParams.Text,
            label: "Fale Conosco",
            link: "/fale-conosco",
            value: "/fale-conosco",
          },
        ],
      },
    },
    Hero1: {
      id: "Hero1",
      position: 0,
      componentName: "Hero1",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      isSmartComponent: true,
      label: "Hero",
      advancedConfig: false,
      smartFeatureName: "inventory",
      styles: {
        classes: [
          ".container",
          ".wrapper",
          ".container__wrapper",
          ".container__wrapper__title",
          ".container__wrapper__description",
          ".container__wrapper__row",
          ".container__wrapper__card",
          ".container__wrapper__card__wrapper",
          ".container__wrapper__card__button",
          ".container__wrapper__image__container",
          ".container__wrapper__image__item",
          ".container__wrapper__card__wrapper__input",
          ".input",
          ".button",
          ".platforms_button",
          ".list-container",
          ".list-item",
          ".button__icon",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
          { label: "05", value: 5 },
        ],
      },
      heading: {
        label: "Titulo",
        type: TypeFieldParams.Text,
        value: "Seu carro ideal com facilidade",
      },
      description: {
        label: "Descrição",
        type: TypeFieldParams.Text,
        value: "Lorem ipsum dolor sit amet.",
      },
      image: {
        label: "Imagem",
        type: TypeFieldParams.Image,
        value: "https://via.placeholder.com/1500x1500.png",
      },
      action: {
        id: "0",
        label: "Botão",
        type: TypeFieldParams.Action,
        value: "Botão",
        icon: true,
        link: "/estoque",
      },
    },
    Hero2: {
      id: "Hero2",
      position: 1,
      componentName: "Hero2",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      isSmartComponent: false,
      label: "Hero2",
      advancedConfig: false,
      image: {
        label: "Imagem",
        type: TypeFieldParams.Image,
        value: "https://via.placeholder.com/120x120.png",
      },
      vendorWhatsAppPhone1: {
        label: "WhatsApp da loja",
        type: TypeFieldParams.Text,
        value: "11 99999-9999",
      },
    },
    PopUp: {
      id: "PopUp",
      position: 0,
      componentName: "PopUp",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      isSmartComponent: false,
      label: "PopUp",
      advancedConfig: false,
      styles: {
        classes: [".container", ".overlay", ".icon"],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      image: {
        label: "Imagem",
        type: TypeFieldParams.Image,
        value: "https://via.placeholder.com/1200x1200.png",
      },
    },
    InterestSearch: {
      id: "InterestSearch",
      position: 0,
      componentName: "InterestSearch",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      isSmartComponent: false,
      label: "InterestSearch",
      advancedConfig: false,
      styles: {
        classes: [".container"],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
    },
    PrivacyPolicy1: {
      id: "PrivacyPolicy1",
      componentName: "PrivacyPolicy1",
      position: 0,
      isSortable: true,
      isSmartComponent: false,
      isDeletable: true,
      label: "Politicas de Privacidade",
      advancedConfig: false,
      isEditable: true,
      styles: {
        classes: [".container", ".wrapper"],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      description: {
        label: "Descrição",
        type: TypeFieldParams.Textarea,
        value: privacyPolicyDescriptionMock,
      },
    },
    SwHome: {
      id: "SwHome",
      position: 0,
      componentName: "SwHome",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      label: "Slider de veículos",
      advancedConfig: false,
      styles: {
        classes: [
          ".section",
          ".container",
          ".wrapper",
          ".images-container",
          ".button-container",
          ".button",
          ".navigation-wrapper",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
          { label: "05", value: 5 },
          { label: "06", value: 6 },
        ],
      },
      isSmartComponent: true,
      smartFeatureName: "inventory",
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
    },
    InstagramPosts: {
      id: "InstagramPosts",
      position: 0,
      componentName: "InstagramPosts",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      label: "Posts do Instagram",
      advancedConfig: false,
      smartFeatureName: "instagram",
      isSmartComponent: true,
      styles: {
        classes: [
          ".section",
          ".container",
          ".title",
          ".instagram__gallery",
          ".instagram__post",
          ".big",
          ".post__content",
          ".content__icons",
          ".icon",
          ".post__description",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      instagramUrl: {
        label: "Url do Instagram",
        type: TypeFieldParams.Text,
        value: "www.instagram.com.br/",
      },
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
    },
    SwModels: {
      id: "SwModels",
      position: 0,
      componentName: "SwModels",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      label: "Comprar por Modelo",
      advancedConfig: false,
      styles: {
        classes: [
          ".container",
          ".title",
          ".content__container",
          ".card",
          ".make",
          ".model",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      isSmartComponent: true,
      smartFeatureName: "inventory",
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
    },
    SwCategory: {
      id: "SwCategory",
      position: 0,
      componentName: "SwCategory",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      label: "Comprar por Categoria",
      advancedConfig: false,
      styles: {
        classes: [],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      isSmartComponent: true,
      smartFeatureName: "inventory",
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
    },
    SwMakes1: {
      id: "SwMakes1",
      position: 0,
      componentName: "SwMakes1",
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      isSmartComponent: true,
      label: "Slider de marcas",
      advancedConfig: false,
      smartFeatureName: "inventory",
      styles: {
        classes: [
          ".section",
          ".container",
          ".wrapper",
          ".text-decorator",
          ".navigation-wrapper",
          ".card",
          ".link",
          ".image",
          ".image--invert",
          ".caroussel_child-wrapper",
        ],
        value: null,
        label: "CSS",
        type: TypeFieldParams.Styles,
      },
      data: {
        shouldRenderDetails: false,
        vehicleList: [],
      },
    },
    StyckFooter1: {
      id: "StyckFooter1",
      componentName: "StyckFooter1",
      position: 0,
      isSortable: true,
      isDeletable: true,
      isSmartComponent: false,
      label: "Rodapé fixo",
      advancedConfig: false,
      isEditable: true,
      styles: {
        classes: [
          ".container",
          ".grid",
          ".grid--3cols",
          ".wrapper",
          ".wrapper--hide",
          ".contact",
          ".icon",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      vendorPhone1: {
        label: "Telefone da loja",
        type: TypeFieldParams.Text,
        value: "11999999999",
      },
      vendorWhatsAppPhone1: {
        label: "WhatsApp da loja",
        type: TypeFieldParams.Text,
        value: "11999999999",
      },
      vendorEmail: {
        label: "E-mail da loja",
        type: TypeFieldParams.Email,
        value: "suporte@sync.com.br",
      },
    },
    StickyNavbar1: {
      id: "StickyNavbar1",
      componentName: "StickyNavbar1",
      position: 0,
      visible: true,
      isSmartComponent: false,
      isSortable: false,
      isDeletable: false,
      isEditable: false,
      label: "Cabeçalho fixo",
      advancedConfig: false,
      styles: {
        classes: [".container", ".wrapper", ".link", ".icon", ".hedden"],
        value: null,
        label: "CSS",
        type: TypeFieldParams.Styles,
      },
      showWhatsapp: {
        label: "Mostrar whatsapp?",
        type: TypeFieldParams.Switch,
        value: true,
      },
      showPhone: {
        label: "Mostrar telefone?",
        type: TypeFieldParams.Switch,
        value: true,
      },
      vendorFullAdress: {
        label: "Endereço da loja",
        type: TypeFieldParams.Text,
        value: "Av. Brasil, 1000",
      },
      vendorPhone1: {
        label: "Telefone da loja",
        type: TypeFieldParams.Text,
        value: "(11) 9 9999-9999",
      },
      vendorWhatsAppPhone1: {
        label: "WhatsApp da loja",
        type: TypeFieldParams.Text,
        value: "https://www.google.com.br/maps/preview",
      },
      linkGPS: {
        label: "Link do google maps",
        type: TypeFieldParams.Text,
        value: "https://www.google.com.br/maps/preview",
      },
    },
    Footer1: {
      id: "Footer1",
      componentName: "Footer1",
      position: 0,
      isSortable: false,
      isDeletable: false,
      isEditable: true,
      isSmartComponent: false,
      visible: true,
      label: "Rodapé",
      advancedConfig: false,
      styles: {
        classes: [
          ".container",
          ".column",
          ".item",
          ".icon-wrapper",
          ".icon",
          ".divider",
          ".text",
          ".w-full",
          ".container__card",
          ".container__card__row",
          ".container__card__column",
          ".container__card__phone",
          ".container__card__phone__label",
          ".container__card__phone__number",
          ".container__card__button",
          ".container__card__button__icon",
          ".inner-card",
          ".inner-card__icon",
          ".container__address",
          ".container__address__label",
          ".container__address__label__decorator",
          ".container__address__item",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      showWhatsapp: {
        label: "Mostrar whatsapp?",
        type: TypeFieldParams.Switch,
        value: true,
      },
      showPhone: {
        label: "Mostrar telefone?",
        type: TypeFieldParams.Switch,
        value: true,
      },
      logo: {
        label: "Logo para o tema claro",
        type: TypeFieldParams.Image,
        value:
          "https://sync-platforms.s3.sa-east-1.amazonaws.com/logo-default.svg",
      },
      logoDark: {
        label: "Logo para o tema escuro",
        type: TypeFieldParams.Image,
        value:
          "https://sync-platforms.s3.sa-east-1.amazonaws.com/logo-default.svg",
      },
      logoWidth: {
        label: "Largura do logo",
        type: TypeFieldParams.Number,
        value: 80,
      },
      logoHeight: {
        label: "Altura do logo",
        type: TypeFieldParams.Number,
        value: 80,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
          { label: "05", value: 5 },
        ],
      },
      action: {
        id: "0",
        label: "Botão",
        type: TypeFieldParams.Action,
        value: "Sync",
        icon: true,
        link: "/sobre",
      },
      nameStore1: {
        value: "Loja 1",
        label: "Digite o nome da loja 1",
        type: TypeFieldParams.Text,
      },
      phoneStore1: {
        value: "11999999999",
        label: "Telefone da Loja 1",
        type: TypeFieldParams.Text,
      },
      whatsappPhone1: {
        value: "11999999999",
        label: "Telefone WhatsApp da Loja 1",
        type: TypeFieldParams.Text,
      },
      addressStore1: {
        value: "Av. 9 de Julho, 999 Jundiai - SP",
        label: "Endereço da Loja 1",
        type: TypeFieldParams.Text,
      },
      nameStore2: {
        value: "Loja 1",
        label: "Digite o nome da loja 2",
        type: TypeFieldParams.Text,
      },
      phoneStore2: {
        value: "11999999999",
        label: "Telefone da Loja 2",
        type: TypeFieldParams.Text,
      },
      whatsappPhone2: {
        value: "11999999999",
        label: "Telefone WhatsApp da Loja 2",
        type: TypeFieldParams.Text,
      },
      addressStore2: {
        value: "Av. 9 de Julho, 999 Jundiai - SP",
        label: "Endereço da Loja 2",
        type: TypeFieldParams.Text,
      },
      openingHours: {
        value: "Segunda a Sexta das 8h às 18h",
        label: "Horário de Funcionamento (Dias de Semana)",
        type: TypeFieldParams.Text,
      },
      openingHours2: {
        value: "Sábado das 8h às 14h",
        label: "Horário de Funcionamento (Sábados)",
        type: TypeFieldParams.Text,
      },
      linkFacebook: {
        value: "https://www.facebook.com",
        label: "Link do Facebook",
        type: TypeFieldParams.Text,
      },
      linkInstagram: {
        value: "https://instagram.com",
        label: "Link do Instagram",
        type: TypeFieldParams.Text,
      },
      linkGPS: {
        label: "Link do google maps",
        type: TypeFieldParams.Text,
        value:
          "https://www.google.com.br/maps/place/Nine+Office+Boutique/@-23.2008363,-46.8946219,17z/data=!3m1!4b1!4m6!3m5!1s0x94cf26bcc05b78fb:0xc1be0e52f873737c!8m2!3d-23.2008413!4d-46.892047!16s%2Fg%2F11c2nr04dg?entry=ttu",
      },
      linkGPS2: {
        label: "Link do google maps",
        type: TypeFieldParams.Text,
        value:
          "https://www.google.com.br/maps/place/Nine+Office+Boutique/@-23.2008363,-46.8946219,17z/data=!3m1!4b1!4m6!3m5!1s0x94cf26bcc05b78fb:0xc1be0e52f873737c!8m2!3d-23.2008413!4d-46.892047!16s%2Fg%2F11c2nr04dg?entry=ttu",
      },
      variation: {
        currentVariationId: "02",
        variations: [
          {
            id: "01",
            nameStore1: {
              value: "Loja 1",
              label: "Digite o nome da loja 1",
              type: TypeFieldParams.Text,
            },
            phoneStore1: {
              value: "11999999999",
              label: "Telefone da Loja 1",
              type: TypeFieldParams.Text,
            },
            whatsappPhone1: {
              value: "11999999999",
              label: "Telefone WhatsApp da Loja 1",
              type: TypeFieldParams.Text,
            },
            addressStore1: {
              value: "Av. 9 de Julho, 999 Jundiai - SP",
              label: "Endereço da Loja 1",
              type: TypeFieldParams.Text,
            },
            nameStore2: {
              value: "Loja 1",
              label: "Digite o nome da loja 2",
              type: TypeFieldParams.Text,
            },
            phoneStore2: {
              value: "11999999999",
              label: "Telefone da Loja 2",
              type: TypeFieldParams.Text,
            },
            whatsappPhone2: {
              value: "11999999999",
              label: "Telefone WhatsApp da Loja 2",
              type: TypeFieldParams.Text,
            },
            addressStore2: {
              value: "Av. 9 de Julho, 999 Jundiai - SP",
              label: "Endereço da Loja 2",
              type: TypeFieldParams.Text,
            },
            openingHours: {
              value: "Segunda a Sexta das 8h às 18h",
              label: "Horário de Funcionamento (Dias de Semana)",
              type: TypeFieldParams.Text,
            },
            openingHours2: {
              value: "Sábado das 8h às 14h",
              label: "Horário de Funcionamento (Sábados)",
              type: TypeFieldParams.Text,
            },
            linkFacebook: {
              value: "https://www.facebook.com",
              label: "Link do Facebook",
              type: TypeFieldParams.Text,
            },
            linkInstagram: {
              value: "https://instagram.com",
              label: "Link do Instagram",
              type: TypeFieldParams.Text,
            },
            linkGPS: {
              label: "Link do google maps",
              type: TypeFieldParams.Text,
              value:
                "https://www.google.com.br/maps/place/Nine+Office+Boutique/@-23.2008363,-46.8946219,17z/data=!3m1!4b1!4m6!3m5!1s0x94cf26bcc05b78fb:0xc1be0e52f873737c!8m2!3d-23.2008413!4d-46.892047!16s%2Fg%2F11c2nr04dg?entry=ttu",
            },
            linkGPS2: {
              label: "Link do google maps",
              type: TypeFieldParams.Text,
              value:
                "https://www.google.com.br/maps/place/Nine+Office+Boutique/@-23.2008363,-46.8946219,17z/data=!3m1!4b1!4m6!3m5!1s0x94cf26bcc05b78fb:0xc1be0e52f873737c!8m2!3d-23.2008413!4d-46.892047!16s%2Fg%2F11c2nr04dg?entry=ttu",
            },
          },
          {
            id: "02",
          },
        ],
      },
    },
    FormContact1: {
      id: "FormContact1",
      position: 0,
      componentName: "FormContact1",
      isSmartComponent: false,
      isSortable: true,
      isDeletable: true,
      isEditable: true,
      label: "Formulário de contato",
      advancedConfig: false,
      actionType: [ActionType.sendEmail],
      button: {
        icon: true,
      },
      styles: {
        classes: [
          ".container",
          ".wrapper",
          ".content",
          ".content-wrapper",
          ".item",
          ".item__wrapper",
          ".item__wrapper__icon",
          ".item__wrapper--spaced",
          ".form",
          ".form__wrapper",
          ".form__wrapper__content",
          ".form__item",
          ".form__error-text",
          ".form__button",
          ".title",
          ".title-wrapper",
          ".text-decorator",
          ".variant2__container",
          ".variant2__neutral-bg",
          ".variant2__content",
          ".variant2__form",
          ".variant2__form__title",
          ".variant2__form__card",
          ".variant2__form__card__content",
          ".variant2__form__card__error-text",
          ".variant2__form__card__label",
          ".variant2__form__card__button",
          ".variant2__form__card__textarea",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      image: {
        value: "https://via.placeholder.com/1250x850.png",
        label: "Adicione uma imagem",
        type: TypeFieldParams.Image,
      },
      formName: {
        value: "Fale Conosco",
        label: "Digite o titúlo do seu formulário",
        type: TypeFieldParams.Text,
      },
      description: {
        value: `<p>Nossa equipe está preparada para te respoder o mais rápido possível e tirar todas as suas dúvidas!</p>`,
        label: "Adicione um texto descritivo para seu formulário",
        type: TypeFieldParams.Textarea,
      },
      n8nWorkflowId: {
        value: "52ca1067-ad78-46bf-af0a-f9b4102880",
        label: "Id do workflow N8N",
        type: TypeFieldParams.Text,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      variation: {
        currentVariationId: "01",
        variations: [
          {
            id: "01",
            formName: {
              value: "Contato",
              label: "Digite o titúlo do seu formulário",
              type: TypeFieldParams.Text,
            },
            description: {
              value: `<p>Nosso principal objetivo é oferecer qualidade e excelência no
            atendimento ao cliente, fornecendo o veículo ideal para atender
            suas necessidades, no momento em que precisar. Dedicamos nossos
            esforços para garantir que sua experiência conosco seja sempre
            satisfatória e positiva.</p>`,
              label: "Adicione um texto descritivo para seu formulário",
              type: TypeFieldParams.Textarea,
            },
            vendorPhone1: {
              value: "(11) 9 9999-9999",
              label: "Telefone de contato",
              type: TypeFieldParams.Text,
            },
            vendorWhatsAppPhone1: {
              value: "(11) 9 9999-9999",
              label: "Whatsapp para contato",
              type: TypeFieldParams.Text,
            },
            n8nWorkflowId: {
              value: "52ca1067-ad78-46bf-af0a-f9b4102880",
              label: "Id do workflow",
              type: TypeFieldParams.Text,
            },
            vendorFullAdress: {
              value: "Av. 9 de Julho, 111 - Jundiaí - SP",
              label: "Digite seu endereço",
              type: TypeFieldParams.Text,
            },
            vendorEmail: {
              value: "suporte@sync.com.br",
              label: "Digite seu email",
              type: TypeFieldParams.Text,
            },
            receiver: {
              value: "suporte@sync.com",
              label: "Quem receberá os dados desse formulario?",
              type: TypeFieldParams.Text,
            },
            fields: {
              value: [
                {
                  label: "Nome",
                  placeholder: "Digite seu nome",
                  type: TypeFieldParams.Text,
                  name: FieldName.name,
                  regex: null,
                  required: true,
                  minLength: 2,
                  maxLength: 100,
                },
                {
                  label: "E-mail",
                  placeholder: "seuemail@teste.com",
                  type: TypeFieldParams.Email,
                  name: FieldName.email,
                  regex: null,
                  required: true,
                  minLength: 5,
                  maxLength: 128,
                },
                {
                  label: "Celular",
                  placeholder: "(11) 99999-9999",
                  type: TypeFieldParams.Tel,
                  name: FieldName.cellphone,
                  regex: null,
                  required: true,
                  minLength: 10,
                  maxLength: 15,
                },
              ],
            },
          },
          {
            id: "02",
            srcImg1: {
              value: "https://via.placeholder.com/450x250.png",
              label: "Adicione a imagem 1",
              type: TypeFieldParams.Image,
            },
            srcImg2: {
              value: "https://via.placeholder.com/450x250.png",
              label: "Adicione a imagem 2",
              type: TypeFieldParams.Image,
            },
            srcImg3: {
              value: "https://via.placeholder.com/450x250.png",
              label: "Adicione a imagem 3",
              type: TypeFieldParams.Image,
            },
            srcImg4: {
              value: "https://via.placeholder.com/450x250.png",
              label: "Adicione a imagem 4",
              type: TypeFieldParams.Image,
            },
            formName: {
              value: "Entre em contato com a gente!",
              label: "Digite o titúlo do seu formulário",
              type: TypeFieldParams.Text,
            },
            n8nWorkflowId: {
              value: "52ca1067-ad78-46bf-af0a-f9b4102880",
              label: "Id do workflow",
              type: TypeFieldParams.Text,
            },
            description: {
              value: `<p>Nossa equipe está preparada para te respoder o mais rápido possível e tirar todas as suas dúvidas!</p>`,
              label: "Adicione um texto descritivo para seu formulário",
              type: TypeFieldParams.Textarea,
            },
            receiver: {
              value: "suporte@sync.com",
              label: "Quem receberá os dados desse formulario?",
              type: TypeFieldParams.Text,
            },
            fields: {
              value: [
                {
                  label: "Nome",
                  placeholder: "Digite seu nome",
                  type: TypeFieldParams.Text,
                  name: FieldName.name,
                  regex: null,
                  required: true,
                  minLength: 2,
                  maxLength: 100,
                },
                {
                  label: "E-mail",
                  placeholder: "exemplo@email.com",
                  type: TypeFieldParams.Email,
                  name: FieldName.email,
                  regex: null,
                  required: true,
                  minLength: 5,
                  maxLength: 128,
                },
                {
                  label: "Celular",
                  placeholder: "11999999999",
                  type: TypeFieldParams.Tel,
                  name: FieldName.cellphone,
                  regex: null,
                  required: true,
                  minLength: 10,
                  maxLength: 15,
                },
                {
                  label: "Mensagem",
                  placeholder: "Mensagem",
                  type: "text",
                  name: FieldName.message,
                  regex: null,
                  required: true,
                  minLength: 1,
                  maxLength: 250,
                },
              ],
            },
          },
        ],
      },
    },
    SwPremiumModule1: {
      id: "SwPremiumModule1",
      componentName: "SwPremiumModule1",
      position: 0,
      isSortable: true,
      shouldRenderDetail: true,
      showPrice: true,
      smartFeatureName: "inventory",
      isDeletable: true,
      isSmartComponent: true,
      isEditable: true,
      label: "Módulo Premium",
      advancedConfig: false,
      styles: {
        classes: [
          ".container",
          ".wrapper",
          ".cards-wrapper",
          ".card",
          ".link",
          ".divider",
          ".armored-container",
          ".highlight",
          ".text",
          ".content",
          ".image",
          ".chip_row",
          ".row",
          ".description",
          ".text-wrapper",
          ".details-wrapper",
          ".make",
          ".information",
          ".info-wrapper",
          ".dd-variant",
          ".wrapper--customDetails",
          ".form-actions",
          ".vehicle-price",
          ".about",
          ".details-wrapper",
          ".send-message-container",
          ".actions-container",
          ".icon",
          ".action-button",
          ".form-container",
          ".form",
          ".wrapper--customDetails",
          ".details-wrapper",
          ".details-wrapper--customDetails",
          ".form-wrapper--customDetails",
          ".vehicle-price",
          ".send-message-container",
          ".actions-container",
          ".chip",
          ".price",
          ".contact",
          ".container__row",
          ".model",
          ".container__row__heading",
          ".button__icon",
          ".small-text",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      options: {
        textAboveVehiclePrice: {
          label: "Texto por cima do preço",
          type: TypeFieldParams.Text,
          value: "",
        },
        galeryType: {
          label: "Qual será a galeria padrão do site?",
          type: TypeFieldParams.Autocomplete,
          selectOptions: [
            { label: "Padrão", value: "default" },
            { label: "Colméia", value: "beehive" },
            { label: "Grid", value: "grid" },
            { label: "Showroom Grid", value: "showroomGrid" },
            { label: "0 KM", value: "brandNew" },
          ],
          value: "default",
        },
        showVehiclePrice: {
          label: "Mostrar o preço do veículo?",
          type: TypeFieldParams.Switch,
          value: true,
        },
        showVehicleKm: {
          label: "Mostrar a quilometragem do veículo?",
          type: TypeFieldParams.Switch,
          value: true,
        },
      },
      contactActions: {
        label: "Ações de contato",
        type: TypeFieldParams.Collection,

        items: [
          {
            actionType: ContactActionType.whatsApp,
            buttonType: ContactActionButtonType.default,
            label: "Chamar no WhatsApp",
            placeholder: "11 99999-9999",
            regex: "",
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
          {
            actionType: ContactActionType.cellphone,
            buttonType: ContactActionButtonType.default,
            label: "Ligar Agora Mesmo",
            placeholder: "11 99999-9999",
            regex: "",
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
          {
            actionType: ContactActionType.whatsApp,
            buttonType: ContactActionButtonType.pulsing,
            label: "Chamar no WhatsApp",
            placeholder: "11 99999-9999",
            regex: "",
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
        ],
      },
    },
    Filter1: {
      id: "VehicleInventory1",
      position: 0,
      componentName: "VehicleInventory1",
      shouldRenderDetail: true,
      showPrice: true,
      isSmartComponent: true,
      smartFeatureName: "inventory",
      isSortable: false,
      isDeletable: false,
      isEditable: false,
      label: "Estoque",
      advancedConfig: true,
      components: ["Filter1", "VehicleDetails1"],
      styles: {
        classes: [
          ".main",
          ".main--4col",
          ".wrapper",
          ".vehicle-container",
          ".container",
          ".wrapper",
          ".cards-wrapper",
          ".card",
          ".link",
          ".divider",
          ".armored-container",
          ".highlight",
          ".text",
          ".content",
          ".image",
          ".chip_row",
          ".row",
          ".description",
          ".text-wrapper",
          ".details-wrapper",
          ".make",
          ".information",
          ".info-wrapper",
          ".dd-variant",
          ".wrapper--customDetails",
          ".form-actions",
          ".vehicle-price",
          ".about",
          ".details-wrapper",
          ".send-message-container",
          ".actions-container",
          ".icon",
          ".action-button",
          ".form-container",
          ".form",
          ".wrapper--customDetails",
          ".details-wrapper",
          ".details-wrapper--customDetails",
          ".form-wrapper--customDetails",
          ".vehicle-price",
          ".send-message-container",
          ".actions-container",
          ".chip",
          ".price",
          ".contact",
          ".container__row",
          ".model",
          ".container__row__heading",
          ".button__icon",
          ".small-text",
          ".container",
          ".wrapper",
          ".row",
          ".order-wrapper",
          ".filter-wrapper",
          ".filter-content",
          ".filter-content__heading",
          ".filter-content__chip_wrapper",
          ".filter-content__chip_wrapper__title",
          ".filter-content__chip_wrapper__content",
          ".disclosure",
          ".chip",
          ".button",
          ".input",
          ".icon",
          ".input-wrapper",
          ".order-container",
          ".item",
          ".year",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
        ],
      },
      contactActions: {
        label: "Ações de contato",
        type: TypeFieldParams.Collection,
        items: [
          {
            actionType: ContactActionType.whatsApp,
            buttonType: ContactActionButtonType.default,
            label: "Chamar no WhatsApp",
            placeholder: "11 99999-9999",
            regex: "",
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
          {
            actionType: ContactActionType.cellphone,
            buttonType: ContactActionButtonType.default,
            label: "Ligar Agora Mesmo",
            placeholder: "11 99999-9999",
            regex: "",
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
          {
            actionType: ContactActionType.whatsApp,
            buttonType: ContactActionButtonType.pulsing,
            label: "Chamar no WhatsApp",
            placeholder: "11 99999-9999",
            regex: "",
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
        ],
      },
      galeryType: {
        label: "Qual será a galeria padrão do site?",
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "Padrão", value: "default" },
          { label: "Colméia", value: "beehive" },
          { label: "Grid", value: "grid" },
          { label: "Showroom Grid", value: "showroomGrid" },
          { label: "0 KM", value: "brandNew" },
        ],
        value: "default",
      },
      variantsMake: {
        label: "Variantes Marca",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
        ],
      },
      cardVariants: {
        label: "Variantes Card",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      options: {
        textAboveVehiclePrice: {
          label: "Texto por cima do preço",
          type: TypeFieldParams.Text,
          value: "",
        },
        workflowId: {
          value: "52ca1067-ad78-46bf-af0a-f9b4102880",
          label: "Id do workflow",
          type: TypeFieldParams.Text,
        },
        galeryType: {
          label: "Qual será a galeria padrão do site?",
          type: TypeFieldParams.Autocomplete,
          selectOptions: [
            { label: "Padrão", value: "default" },
            { label: "Colméia", value: "beehive" },
            { label: "Grid", value: "grid" },
            { label: "Showroom Grid", value: "showroomGrid" },
            { label: "0 KM", value: "brandNew" },
          ],
          value: "default",
        },
        quantityPerPage: {
          type: TypeFieldParams.Number,
          label: "Quantidade por página:",
          value: 10,
        },
        increaseVehiclePriceInPercentage: {
          type: TypeFieldParams.Number,
          label: "Aumentar/Diminuir o estoque do veículo em %",
          value: 0,
        },
        increaseVehiclePriceAmount: {
          type: TypeFieldParams.Number,
          label: "Aumentar o preço do estoque num valor fixo",
          value: 0,
        },
        showDataLayerForm: {
          type: TypeFieldParams.Switch,
          label: "Mostrar formlário de coleta avançada?",
          value: false,
        },
        emailToSendLead: {
          label: "Email que receberá leads",
          type: TypeFieldParams.Text,
          value: "example@email.com",
        },
        showMakeFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por marca?",
          value: true,
        },
        showVehiclePrice: {
          type: TypeFieldParams.Switch,
          label: "Mostrar preço do veículo?",
          value: true,
        },
        showVehicleKm: {
          type: TypeFieldParams.Switch,
          label: "Mostrar KM do veículo?",
          value: true,
        },
        showModelFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por modelo?",
          value: true,
        },
        showCategoryFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por categoria?",
          value: true,
        },
        showYearFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por ano?",
          value: true,
        },
        showPriceFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por preço?",
          value: true,
        },
        showKmFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por KM?",
          value: true,
        },
        showSort: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação?",
          value: true,
        },
        showSortByYear: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação por ano?",
          value: true,
        },
        showSortByPrice: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação por preço?",
          value: true,
        },
        showSortByKm: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação por KM?",
          value: true,
        },
        showPagination: {
          type: TypeFieldParams.Switch,
          label: "Mostrar paginação?",
          value: true,
        },
      },
    },
    VehicleInventory1: {
      id: "VehicleInventory1",
      position: 0,
      componentName: "VehicleInventory1",
      shouldRenderDetail: true,
      showPrice: true,
      isSmartComponent: true,
      smartFeatureName: "inventory",
      isSortable: false,
      isDeletable: false,
      isEditable: false,
      label: "Estoque",
      variants: {
        label: "Variantes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
        ],
      },
      advancedConfig: true,
      components: ["Filter1", "VehicleDetails1"],
      styles: {
        classes: [
          ".main",
          ".main--4col",
          ".wrapper",
          ".vehicle-container",
          ".container",
          ".wrapper",
          ".wrapper--customDetails",
          ".details",
          ".details-wrapper",
          ".details-wrapper--customDetails",
          ".form-wrapper",
          ".form-wrapper--customDetails",
          ".information",
          ".divider",
          ".about",
          ".form-container",
          ".price",
          ".contact",
          ".form",
          ".form label",
          ".form input",
          ".form textarea",
          ".form button",
          ".form-actions",
          ".vehicle-price",
          ".send-message-container",
          ".send-message-container .title",
          ".send-message-container .actions-container",
          ".action-button",
          ".action-button--darken",
          ".card",
          ".card--adjust-height",
          ".image",
          ".content",
          ".highlight",
          ".text-wrapper",
          ".description",
          ".main",
          ".main--4col",
          ".wrapper",
          ".vehicle-container",
          ".container",
          ".wrapper",
          ".cards-wrapper",
          ".card",
          ".link",
          ".divider",
          ".armored-container",
          ".highlight",
          ".text",
          ".content",
          ".image",
          ".chip_row",
          ".row",
          ".description",
          ".text-wrapper",
          ".details-wrapper",
          ".make",
          ".information",
          ".info-wrapper",
          ".dd-variant",
          ".wrapper--customDetails",
          ".form-actions",
          ".vehicle-price",
          ".about",
          ".details-wrapper",
          ".send-message-container",
          ".actions-container",
          ".icon",
          ".action-button",
          ".form-container",
          ".form",
          ".wrapper--customDetails",
          ".details-wrapper",
          ".details-wrapper--customDetails",
          ".form-wrapper--customDetails",
          ".vehicle-price",
          ".send-message-container",
          ".actions-container",
          ".chip",
          ".price",
          ".contact",
          ".container__row",
          ".model",
          ".container__row__heading",
          ".button__icon",
          ".small-text",
          ".container",
          ".wrapper",
          ".row",
          ".order-wrapper",
          ".filter-wrapper",
          ".filter-content",
          ".filter-content__heading",
          ".filter-content__chip_wrapper",
          ".filter-content__chip_wrapper__title",
          ".filter-content__chip_wrapper__content",
          ".disclosure",
          ".chip",
          ".button",
          ".input",
          ".icon",
          ".input-wrapper",
          ".order-container",
          ".item",
          ".year",
        ],
        label: "CSS",
        value: null,
        type: TypeFieldParams.Styles,
      },
      contactActions: {
        label: "Ações de contato",
        type: TypeFieldParams.Collection,
        items: [
          {
            actionType: ContactActionType.whatsApp,
            buttonType: ContactActionButtonType.default,
            label: "Chamar no WhatsApp",
            placeholder: "11 99999-9999",
            regex: "",
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
          {
            actionType: ContactActionType.cellphone,
            buttonType: ContactActionButtonType.default,
            label: "Ligar Agora Mesmo",
            placeholder: "11 99999-9999",
            regex: "",
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
          {
            actionType: ContactActionType.whatsApp,
            buttonType: ContactActionButtonType.pulsing,
            label: "Chamar no WhatsApp",
            placeholder: "11 99999-9999",
            regex: "",
            required: {
              label: "Campo obrigatório?",
              type: TypeFieldParams.Checkbox,
              value: true,
            },
            receiver: {
              label: "Receiver",
              type: TypeFieldParams.Text,
              value: "",
            },
            link: {
              label: "Numero",
              type: TypeFieldParams.Text,
              value: "",
            },
          },
        ],
      },
      variantsMake: {
        label: "Variantes Marca",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
        ],
      },
      cardVariants: {
        label: "Variantes Card",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
          { label: "03", value: 3 },
          { label: "04", value: 4 },
        ],
      },
      detailsVariants: {
        label: "Variantes detalhes",
        value: 1,
        type: TypeFieldParams.Autocomplete,
        selectOptions: [
          { label: "01", value: 1 },
          { label: "02", value: 2 },
        ],
      },
      options: {
        textAboveVehiclePrice: {
          label: "Texto por cima do preço",
          type: TypeFieldParams.Text,
          value: "",
        },
        workflowId: {
          value: "52ca1067-ad78-46bf-af0a-f9b4102880",
          label: "Id do workflow",
          type: TypeFieldParams.Text,
        },
        galeryType: {
          label: "Qual será a galeria padrão do site?",
          type: TypeFieldParams.Autocomplete,
          selectOptions: [
            { label: "Padrão", value: "default" },
            { label: "Colméia", value: "beehive" },
            { label: "Grid", value: "grid" },
            { label: "Showroom Grid", value: "showroomGrid" },
            { label: "0 KM", value: "brandNew" },
          ],
          value: "default",
        },
        quantityPerPage: {
          type: TypeFieldParams.Number,
          label: "Quantidade por página:",
          value: 10,
        },
        increaseVehiclePriceInPercentage: {
          type: TypeFieldParams.Number,
          label: "Aumentar/Diminuir o estoque do veículo em %",
          value: 0,
        },
        increaseVehiclePriceAmount: {
          type: TypeFieldParams.Number,
          label: "Aumentar o preço do estoque num valor fixo",
          value: 0,
        },
        showDataLayerForm: {
          type: TypeFieldParams.Switch,
          label: "Mostrar formulário de coleta avançada?",
          value: false,
        },
        emailToSendLead: {
          label: "Email que receberá leads",
          type: TypeFieldParams.Text,
          value: "example@email.com",
        },
        showMakeFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por marca?",
          value: true,
        },
        showVehiclePrice: {
          type: TypeFieldParams.Switch,
          label: "Mostrar preço do veículo?",
          value: true,
        },
        showVehicleKm: {
          type: TypeFieldParams.Switch,
          label: "Mostrar KM do veículo?",
          value: true,
        },
        showModelFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por modelo?",
          value: true,
        },
        showCategoryFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por categoria?",
          value: true,
        },
        showYearFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por ano?",
          value: true,
        },
        showPriceFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por preço?",
          value: true,
        },
        showKmFilter: {
          type: TypeFieldParams.Switch,
          label: "Mostrar filtro por KM?",
          value: true,
        },
        showSort: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação?",
          value: true,
        },
        showSortByYear: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação por ano?",
          value: true,
        },
        showSortByPrice: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação por preço?",
          value: true,
        },
        showSortByKm: {
          type: TypeFieldParams.Switch,
          label: "Mostrar ordenação por KM?",
          value: true,
        },
        showPagination: {
          type: TypeFieldParams.Switch,
          label: "Mostrar paginação?",
          value: true,
        },
        useCustomDetails: {
          type: TypeFieldParams.Switch,
          label: "Mostrar detalhes customizados?",
          value: true,
        },
      },
    },
    Seo: {
      id: "Seo",
      componentName: "Seo",
      position: 0,
      visible: true,
      isDeletable: false,
      isSortable: false,
      isEditable: true,
      isSmartComponent: false,
      label: "Seo",
      advancedConfig: false,
      titlePage: {
        type: TypeFieldParams.Text,
        label: "Título da página",
        value: "AutoWeb",
      },
      titleOG: {
        type: TypeFieldParams.Text,
        label: "Título da página OG",
        value: "AutoWeb OG",
      },
      imgOG: {
        type: TypeFieldParams.Image,
        label: "Image OG",
        value: "",
      },
      twitterTitle: {
        type: TypeFieldParams.Text,
        label: "Título do compartilhamento do twitter",
        value: "AutoWeb Twitter",
      },
      descriptionPage: {
        type: TypeFieldParams.Textarea,
        label: "Descrição da página",
        value: "Melhor site para compra de automoveis.",
      },
      descriptionOG: {
        type: TypeFieldParams.Textarea,
        label: "Descrição da página OG",
        value: "Melhor site para compra de automoveis.",
      },
      twitterDescription: {
        type: TypeFieldParams.Textarea,
        label: "Descrição da página Twitter",
        value: "Melhor site para compra de automoveis.",
      },
      twitterImg: {
        type: TypeFieldParams.Image,
        label: "Image Twitter",
        value: "",
      },
      websiteDomain: {
        type: TypeFieldParams.Text,
        label: "Doiminio do site",
        value: "",
      },
      pageName: {
        type: TypeFieldParams.Text,
        label: "Nome da página",
        value: "",
      },
      address: {
        type: TypeFieldParams.Text,
        label: "Endereço",
        value: "",
      },
      openingHours: {
        type: TypeFieldParams.Text,
        label: "Horario de funcionamento",
        value: "09:00-18:00",
      },
      contactPhone: {
        type: TypeFieldParams.Text,
        label: "Telefone para contato",
        value: "11 9 9999 9999",
      },
      hrefIconDefault: {
        type: TypeFieldParams.Image,
        label: "Icone do site",
        value: "",
      },
      siteLogo: {
        type: TypeFieldParams.Image,
        label: "Logo da empresa",
        value: "",
      },
    },
  })
);
